@if (icon) {
  @if (material) {
    <mat-icon class="core-icon size-{{ size }}">{{ icon }}</mat-icon>
  } @else {
    <mat-icon class="core-icon size-{{ size }}" [svgIcon]="icon!"> </mat-icon>
  }
}
